import { Box, Grid, GridItem, Heading, Link, SimpleGrid, Text, Container } from "@chakra-ui/react";
import React from "react";
import parser from "html-react-parser";

const ContentBlock = ({ page, block }) => {

    let titleColor = block.entry.title_color ? block.entry.title_color : "rgb(213, 31, 12)";

    console.log(titleColor);

    return (
        <Box className="category-wrapper" pt={10} pb={10} backgroundImage={`url(${block.img})`} backgroundPosition="center center" backgroundSize="cover">
            <Container maxW={'5xl'}>
                <div className="experiences-header">
                    <Heading
                        as={'h2'}
                        fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                        textAlign={{ base: 'center', md: 'center' }}
                        lineHeight={'110%'}
                        color={titleColor}>
                        {block.title}
                    </Heading>
                </div>
                {block.entry.content != null ? (
                    <Box className="content-block" bg="white" p={10} textAlign="left" roundedBottomRight={20}>
                        {parser(block.entry.content)}
                    </Box>
                ) : null}
            </Container>
        </Box>
    )
};

export default ContentBlock;